import { createStore } from "easy-peasy";
import storeModel from "./models";

const store = createStore(storeModel, {
	name: "RawyyStore",
});

export default store;
